import {Middleware} from 'redux';

import {
    navigationGo,
    navigationGoBack,
    navigationGoForward,
    navigationPush,
    navigationReplace,
    NavigationAction,
} from '../../router';
import {history} from '../history';

/** Bridges navigation actions to the shared browser history instance. */
// eslint-disable-next-line unicorn/consistent-function-scoping
export const navigationMiddleware: Middleware = _store => next =>
    (action: NavigationAction) => {
        switch (action.type) {
            case navigationPush: {
                const {path, state} = action.payload;
                history.push(path, state);
                break;
            }
            case navigationReplace: {
                const {path, state} = action.payload;
                history.replace(path, state);
                break;
            }
            case navigationGo: {
                history.go(action.payload);
                break;
            }
            case navigationGoBack: {
                history.back();
                break;
            }
            case navigationGoForward: {
                history.forward();
                break;
            }
            default:
                break;
        }

        return next(action);
    };
